export default "__VITE_ASSET__510bfa68__"